export default {"src":"/_next/static/image/public/images/no_insurance_found.f87db84340f88410c8556956274836f6.svg","height":151,"width":138};